
export const makeSlots = (fn) => {
    fn.proxy = true
    return fn
}

export const commonUpdateSalary = () => ({
    adjust_ratio: null,
    payment_place: null,
    company_endowment_ratio: null,
    company_medical_ratio: null,
    company_unemployment_ratio: null,
    company_industrial_injury_ratio: null,
    company_maternity_ratio: null,
    company_accumulation_fund_ratio	: null,
    person_endowment_ratio: null,
    person_medical_ratio: null,
    person_unemployment_ratio: null,
    person_industrial_injury_ratio: 0,
    person_maternity_ratio: 0,
    person_accumulation_fund_ratio: null,
    adjust_reason: null,
})

export const initUpdateSalary = () => ({
    id: null,
    salary: null,
    ...commonUpdateSalary()
})

export const getEmployeeType = (item = {}) => {
    let text = ''
    if (item.customer_type === 50 && item.customer_sub_type === 0) {
        text = '正式-销服'
    } else if (item.customer_type === 0 && item.customer_sub_type === 0) {
        text = '正式-产研'
    } else if (item.customer_type === 20 && item.customer_sub_type === -1) {
        text = '劳务派遣'
    } else if (item.customer_type === 10 && item.customer_sub_type === 1) {
        text = '实习生（外包）'
    } else if (item.customer_type === 50 && item.customer_sub_type === 2) {
        text = '外包（大规模）'
    } else if (item.customer_type === 40 && item.customer_sub_type === -1) {
        text = '外包员工'
    } 
    return text
}

export const setSG = () => ({
    id: null,
    payment_place: null,
    company_endowment_ratio: null,
    company_medical_ratio: null,
    company_unemployment_ratio: null,
    company_industrial_injury_ratio: null,
    company_maternity_ratio: null,
    company_supplementary_medical_ratio: null,
    company_accumulation_fund_ratio: null,
    person_endowment_ratio: null,
    person_medical_ratio: null,
    person_unemployment_ratio: null,
    person_industrial_injury_ratio: null,
    person_maternity_ratio: null,
    person_accumulation_fund_ratio: null,
    person_supplementary_medical_ratio: null,
    endowment_insurance_payment_base: null,
    medical_insurance_payment_base: null,
    unemployment_insurance_payment_base: null,
    industrial_injury_insurance_payment_base: null,
    maternity_insurance_payment_base: null,
    supplementary_medical_payment_base: null,
    accumulation_fund_payment_base: null,
    effective_time: null,
})

export const createSalaryAdjust = () => ({
    customer_id: null,
    basic_salaries_id: null,
    effective_time: null,
    adjust_type: null,
    current_salary: null,
    adjusted_salary: null,
    adjust_ratio: null,
    id: undefined,
    adjust_level: null,
    apply_type: null,
    adjust_reason: null,
})


export const createSalaryAdjustV2Display = () => ({
    customer_name: null,
    id_number: null,
    bank_number: null,
    company: null,
    payment_place: null,
    fl_employee_type: null,
})
export const createSalaryAdjustV2Submit = () => ({
    customer_month_salary_detail_id: null,
    enter_quit_adjust_salary: null,
    last_month_supply_salary: null,
    leave_deduct_salary: null,
    other_subsidy: null,
    meal_subsidy: null,
    company_id: null,
    company_name: null,
    recommend_award: null,
    company_endowment_amount: null,
    company_medical_amount: null,
    company_maternity_amount: null,
    company_unemployment_amount: null,
    company_industrial_injury_amount: null,
    company_supplementary_medical_amount: null,
    company_accumulation_fund_amount: null,
    person_endowment_amount: null,
    person_medical_amount: null,
    person_unemployment_amount: null,
    person_accumulation_fund_amount: null,
    person_supplementary_medical_amount: null,
    child_edu_deduct: null,
    housing_loan_deduct: null,
    housing_rent_deduct: null,
    support_older_deduct: null,
    continuing_edu_deduct: null,
    baby_tend_deduct: null,
    social_security_flag: null,
    accumulation_fund_flag: null,
    individual_tax: null,
    severance: null,
    severance_tax: null,
    non_competition: null,
    option: null,
    payment_batch: null,
    account_nature: null,
    reason: null,
    team_id: null,
    team_name: null,
    wage_memo: null,
    other_subsidy_memo: null,
    personal_pension: null,
})

export const createSalaryAdjustV2 = () => ({
    ...createSalaryAdjustV2Display(),
    ...createSalaryAdjustV2Submit()
})